import fileStackConfig from './fileStackConfig';
import * as filestack from 'filestack-js';

const fileStackClient = (callback, {policy, signature}) => {
    if (!fileStackConfig) return null;  // if fileStack config fails to load from env vars exit to avoid throwing err

    const clientOptions = {
        security: { policy, signature }
    };

    const pickerOptions = {
        fromSources: ['local_file_system'],
        accept: ['image/*'],
        maxSize: 20971520,
        lang: 'en',
        storeTo: {
            location: 's3',
            container: fileStackConfig.container,
            region: fileStackConfig.region
        },
        onFileUploadFinished: file => callback({
            url: `${file.url}?policy=${policy}&signature=${signature}`,
            alt: file.filename
        })
    };

    const client = filestack.init(fileStackConfig.key, clientOptions);

    return client.picker(pickerOptions);
};

export default fileStackClient;
